import OriginalFeed from './Feed.svelte';
import OriginalItem from './Item.svelte';
import Connector from './Connector.svelte';
import Avatar from './Avatar.svelte';
import DateTime from './DateTime.svelte';
import Icon from './Icon.svelte';
import OriginalLeading from './Leading.svelte';
import Content from './Content.svelte';
const Feed = OriginalFeed;
Feed.Item = OriginalItem;
Feed.Item.Connector = Connector;
Feed.Item.Leading = OriginalLeading;
Feed.Item.Leading.Avatar = Avatar;
Feed.Item.Leading.Icon = Icon;
Feed.Item.DateTime = DateTime;
Feed.Item.Content = Content;
export default Feed;
